import { useState } from "react";

const useTableMenu = () => {
	const [openCard, setOpenCard] = useState<boolean>(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [menuOpen, setMenuOpen] = useState(false);

	const handleOpenCard = () => {
		setOpenCard(true);
	}

	const handleCloseCard = () => {
        setOpenCard(false);
  };

	const anchorToEventElement = (event: any) => {
        setAnchorEl(event.currentTarget);
  };

	const closeMenu = () => {
        setMenuOpen(false);
    };

    const openMenu = () => {
        setMenuOpen(true);
    };

	return {
        handleOpenCard,
        handleCloseCard,
        anchorToEventElement,
        closeMenu,
        openMenu,
        openCard,
        anchorEl,
        menuOpen
    };
}

export default useTableMenu;